module.exports = function (value, defaultValue) {
  if (value) {
    return value;
  }
  return defaultValue;
  // return !_.isUndefined(value) && !_.isNull(value) ? value : defaultValue;
};